// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonFlag_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2 0H1V12H2V6.43465C3.00476 6.78261 4.63396 7.11341 6.26316 6.45211C7.78778 5.83326 9.13575 6.11538 10 6.46223C10.6275 6.71405 11 7 11 7V0.778556C11 0.778556 8.89474 -0.706149 6.26316 0.425022C4.63396 1.12533 3.00476 0.795617 2 0.442837V0ZM2 1.49504V5.36664C2.23439 5.46202 2.53717 5.56901 2.88712 5.65644C3.75415 5.87305 4.83614 5.9521 5.88706 5.52553C7.47053 4.88279 8.90251 5.05025 9.91997 5.37204C9.94692 5.38057 9.9736 5.3892 10 5.39794V1.37115C9.828 1.29403 9.61138 1.21117 9.35896 1.14335C8.6682 0.957769 7.72213 0.886361 6.65807 1.34374C5.07162 2.02567 3.51379 1.8858 2.40133 1.60662C2.26146 1.57152 2.12746 1.53395 2 1.49504Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M3 0H1V8.88901V16H3V9.56112C4.40814 9.88116 6.38828 10.0374 8.36842 9.2173C10.177 8.4682 11.8081 8.6432 13 9.01553C14.2361 9.40165 15 10 15 10V1.11222C15 1.11222 12.0526 -1.00878 8.36842 0.607175C6.38828 1.4757 4.40814 1.23522 3 0.826955V0ZM3 2.89486V7.49816C3.2085 7.55685 3.44006 7.6139 3.69008 7.66327C4.83785 7.88992 6.24721 7.93111 7.6031 7.36952C9.65406 6.52004 11.5405 6.59201 13 6.94205V2.33248C12.8595 2.2798 12.7046 2.22848 12.537 2.18254C11.6751 1.94624 10.5029 1.85488 9.17178 2.43874C6.87276 3.44712 4.62541 3.2817 3 2.89486Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4 0H2V0.388928V2.5685V11.7436V24H4V12.3215C5.82494 12.7022 8.66247 12.9405 11.5 11.7759C14.5018 10.5439 17.9031 11.358 20 12.124C21.2212 12.5701 22 13 22 13V10.7778V1.49997C22 1.49997 16.25 -1.28855 11.5 0.775942C8.66247 2.00922 5.82494 1.63093 4 1.12639V0ZM4 3.19142V10.2715C4.35767 10.3583 4.77911 10.4442 5.24865 10.5105C6.81239 10.7316 8.80049 10.722 10.7406 9.92571C13.7099 8.70706 16.8473 9.12926 19.0537 9.72635C19.3846 9.81591 19.701 9.91113 20 10.0085V2.85187C19.4902 2.6742 18.8418 2.47709 18.1087 2.31862C16.2588 1.91876 14.1189 1.81841 12.2972 2.61018C9.42545 3.85834 6.60341 3.72153 4.57804 3.31809C4.37867 3.27837 4.18579 3.23585 4 3.19142Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonFlag is a generated icon component.
 */
let IconCommonFlag = IconCommonFlag_1 = class IconCommonFlag extends IconBaseElement {
    render() {
        return html `${IconCommonFlag_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonFlag.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonFlag = IconCommonFlag_1 = __decorate([
    customElement('zui-icon-common-flag')
], IconCommonFlag);
export { IconCommonFlag };
